import React from 'react';
import styles from './Maintenance.module.scss';

const MaintenancePage = () => (
  <div className={styles['maintenance-container']}>
    <h1 className={styles['maintenance-title']}>Le chatbot est en maintenance</h1>
    <p className={styles['maintenance-message']}>Nous serons de retour bientôt.</p>
    <p className={styles['maintenance-subtext']}>
      Merci de votre patience ! Si vous avez besoin d’aide immédiate, veuillez contacter notre équipe de support.
    </p>
  </div>
);

export default MaintenancePage;
